<template>
  <div class="consult-schedule-list-top">
    <div class="info">
      <h2 class="desc">最新入驻</h2>
      <h1 class="title">壹心理咨询师新势力</h1>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.consult-schedule-list-top {
  display: flex;
  justify-content: flex-end;
  // background: url('../../images/consult/scheduleList/top-bg.png') no-repeat
  //   center / 100% 100%;
  flex-direction: column;

  background: url(~app/web/images/consult/special/latest-bg.png) no-repeat top
    center / 100% auto;
  height: 390px;
  .info {
    box-sizing: border-box;
    padding: 50px 30px;
    padding-right: 336px;
    color: #ffffff;
  }

  .title {
    font-size: 40px;
    line-height: 72px;
    // padding-bottom: 15px;
  }

  .desc {
    font-size: 28px;
    line-height: 48px;
    font-weight: normal;
  }
}
</style>
